import React, { FC, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Fade,
} from '@mui/material';
import { Modal } from '../../components';
import { Save, Close } from '@mui/icons-material';
import { IOccupierService, IDropdownResponse } from '../../models';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { theme } from '../../styles';

interface AddEditOccupierServiceModalProps {
  open: boolean;
  occupierService?: IOccupierService;
  occupierServiceProductTypes?: IDropdownResponse[];
  onClose: () => void;
  onSave: (updatedOccupierService: IOccupierService) => void;
}

export const AddEditOccupierServiceModal: FC<AddEditOccupierServiceModalProps> = ({
  open,
  occupierService,
  occupierServiceProductTypes = [],
  onClose,
  onSave,
}) => {
  const classes = useStyles();
  const [localOccupierService, setLocalOccupierSevice] = useState<IOccupierService>(occupierService ? { ...occupierService } : IOccupierService.getDefault());

  useEffect(() => {
    if (open) {
        setLocalOccupierSevice(occupierService ? { ...occupierService } : IOccupierService.getDefault());
    }
  }, [open, occupierService]);

  const handleChange = (field: keyof IOccupierService, value: any) => {
    setLocalOccupierSevice(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    onSave(localOccupierService);
  };

  const isSaveDisabled =
    !localOccupierService.productType || !localOccupierService.category;

  return (
    <Modal
      maxWidth="sm"
      open={open}
      onClose={onClose}
      title={localOccupierService.occupierServicesId ? 'Edit Category' : 'Add Category'}
    >
      <Fade in={open}>
        <Box component="form" autoComplete="off" className={classes.form}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                required
                select
                label="Product Type"
                fullWidth
                variant="outlined"
                value={localOccupierService.productType || ''}
                onChange={e => handleChange('productType', e.target.value)}
              >
                {occupierServiceProductTypes.map(et => (
                  <MenuItem key={et.value} value={et.description}>
                    {et.description}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Industry/Category"
                fullWidth
                variant="outlined"
                value={localOccupierService.category || ''}
                onChange={e => handleChange('category', e.target.value)}
              />
            </Grid>
            
          </Grid>
          <Grid container spacing={1} justifyContent="flex-end" className={classes.buttonRow}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleSave}
                disabled={isSaveDisabled}
                startIcon={<Save />}
              >
                Add Category
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={onClose} startIcon={<Close />}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

const useStyles = makeStyles<Theme>(() => ({
  form: {
    padding: theme.spacing(1),
    width: '100%',
    boxSizing: 'border-box',
  },
  buttonRow: {
    marginTop: theme.spacing(1),
  },
}));
